export default {
  props: {
    isResultLoaded: {
      type: Boolean,
      default: false
    },
    isScopedSearch: {
      type: Boolean,
      default: false
    },
    isFilterLoaded: {
      type: Boolean,
      default: false
    },
    isFilterSetLoaded: {
      type: Boolean,
      default: false
    },
    isInitSearchLoaded: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      required: true
    },
    filterSets: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data () {
    return {
      filters: {},
      styles: {}
    }
  },
  mounted () {
    if (this.isFilterLoaded) this.filters = this.sortFilters(this.state.filters)
  },
  computed: {
    canViewFilters () {
      return this.isScopedSearch || this.$can('viewFilters')
    },
    canUseFilters () {
      return this.isScopedSearch || this.$can('useFilters')
    },
    areAllFiltersOpen () {
      const i = Object.values(this.state.filters).findIndex(f => {
        return f.collapsed && !f.hide
      })
      return i === -1
    },
    areAllFiltersInSectionOpen () {
      return (filters) => {
        const i = Object.values(filters).findIndex(f => {
          return f.collapsed && !f.hide
        })
        return i === -1
      }
    },
    hasActiveBucket () {
      for (let filter in this.state.filters) {
        if (!this.state.filters[filter].hide && !this.isEmpty(this.state.filters[filter].buckets)) {
          for (let bucket of this.state.filters[filter].buckets) {
            if (bucket.active) {
              return true
            }
          }
        }
      }
      return false
    },
    sectionedFilters () {
      if (this.isEmpty(this.filters)) return {}

      const sections = {}

      Object.entries(this.filters).forEach(([key, value]) => {
        sections[value.group] = sections[value.group] || []
        sections[value.group].push({
          ...value,
          name: key
        })
      })

      return sections
    }
  },
  watch: {
    isFilterLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.filters = this.sortFilters(this.state.filters)
      }
    },
    'state.filters' (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.filters = this.sortFilters(this.state.filters)
      }
    }
  },
  methods: {
    toggleSection (name) {
      // Check if _any_ filter is closed (collapsed)
      const areAllFiltersOpen = this.areAllFiltersInSectionOpen(this.sectionedFilters[name])
      // if all are open: close all filters; if 1 or more is closed, open all filters

      this.sectionedFilters[name].forEach(filter => {
        // Collapse all filters if they are all open
        if (areAllFiltersOpen) {
          this.filters[filter.name].collapsed = true
          this.filters[filter.name].isLoading = false
        } else {
          // Open all filters if 1 or more is collapsed
          this.filters[filter.name].collapsed = false
          this.filters[filter.name].isLoading = true
        }
      })
      this.$emit('handleCollapseFilterSection', this.filters, areAllFiltersOpen)
    },
    sortFilters (filters) {
      let sortedFilters = {}
      for (let sorted of this.sortProperties(filters)) sortedFilters[sorted[0]] = sorted[1]
      return sortedFilters
    },
    sortProperties (filters) {
      let sortable = []
      for (let key in filters) {
        if (filters.hasOwnProperty(key) && !filters[key].hide) sortable.push([key, filters[key]])
      }
      sortable.sort((a, b) => a[1].order - b[1].order)
      return sortable
    },
    handleBucketToggled (bucket, filterName, filterSetToDeactivate = null) {
      this.$emit('bucketToggled', bucket, filterName, this.filters, filterSetToDeactivate)
      setTimeout(this.calculateInnerScroll, 100)
    },
    handleSetToggled (bucket) {
      this.$emit('setToggled', bucket)
    },
    handleBucketSinceToggled (bucket, filterName) {
      bucket.active = !bucket.active

      let isNewBucket = true
      let filterSetToDeactivate = null
      for (let b of this.filters[filterName].buckets) {
        if (b.active && b.filter_from_set) {
          filterSetToDeactivate = b.filter_from_set
        }
        if (b.value === bucket.value) {
          b.active = bucket.active
          isNewBucket = false
        } else {
          b.active = false
        }
      }

      if (isNewBucket && this.isEmpty(this.filters[filterName].buckets)) {
        this.filters[filterName].buckets = []
        this.filters[filterName].buckets.push(bucket)
      } else if (isNewBucket && !this.isEmpty(this.filters[filterName].buckets)) {
        this.filters[filterName].buckets.push(bucket)
      }

      this.handleBucketToggled(bucket, filterName, filterSetToDeactivate)
    },
    handleBucketDateToggled (bucket, filterName) {
      if (this.isEmpty(this.filters[filterName]) || this.isEmpty(this.filters[filterName].buckets)) {
        this.filters[filterName].buckets = []
        this.filters[filterName].buckets[0] = bucket
      } else {
        this.filters[filterName].buckets[0] = bucket
      }

      this.handleBucketToggled(bucket, filterName)
      setTimeout(this.calculateInnerScroll, 100)
    },
    handleBucketAdded (bucket, filterName) {
      this.$emit('bucketAdded', bucket, filterName)
      setTimeout(this.calculateInnerScroll, 100)
    },
    handleBucketShowAll (filterName, filter) {
      this.$emit('bucketShowAll', filterName, filter)
      setTimeout(this.calculateInnerScroll, 100)
    },
    handleCollapseToggled (filterName, filter) {
      if (filterName === 'quick_filters') {
        this.filterSets.collapsed = !this.filterSets.collapsed
      } else {
        this.filters[filterName].collapsed = !filter.collapsed
        this.filters[filterName].isLoading = !filter.isLoading

        this.$emit('filterCollapseToggled', filterName, this.filters[filterName])
      }
      setTimeout(this.calculateInnerScroll, 100)
    },
    handleCollapseAllToggled () {
      const shouldCloseAllFilters = this.areAllFiltersOpen

      for (let key in this.filters) {
        this.filters[key].collapsed = shouldCloseAllFilters
        this.filters[key].isLoading = !this.filters[key].isLoading
      }

      this.$emit('filterCollapseAllToggled', this.filters, shouldCloseAllFilters)
      setTimeout(this.calculateInnerScroll, 100)
    }
  }
}
